import type { Directive } from 'vue';

export const vIntersect: Directive = {
  mounted(el, binding) {
    const observer = new IntersectionObserver(
      (entries) => {
        const entry = entries[0];
        if (!entry) return;
        if (entry.isIntersecting) {
          binding.value?.(entry);
        }
      },
      {
        root: null, // viewport
        threshold: 0.1, // 10% visible triggers
      },
    );

    observer.observe(el);

    el.__observer = observer;
  },

  unmounted(el) {
    el.__observer?.disconnect();
  },
};
